import { RefString, RefBool, RefDate, RefNumber } from "@tblabs/truffle";
import { StepData } from "../../Step/StepData";
import { EventStepRawData } from "./EventStepRawData";
import { EventStepState } from "./EventStepState";


export class EventStepData extends StepData
{
    public Title = new RefString();
    public Info = new RefString();
    public VisibleForCustomer = new RefBool();
    public PlannedTime = new RefDate();
    public ExecutionTime = new RefDate();
    public Cost = new RefNumber();
    public Profit = new RefNumber();

    constructor(raw: Partial<EventStepRawData>)
    {
        super(raw);

        this.State.value ||= EventStepState.Preparing;

        this.Title.value = raw?.Title || "";
        this.Info.value = raw?.Info || "";
        this.VisibleForCustomer.value = raw?.VisibleForCustomer || false;
        this.PlannedTime.value = new Date(raw?.PlannedTime || 0);
        this.ExecutionTime.value = new Date(raw?.ExecutionTime || 0);
        this.Cost.value = raw?.Cost || 0;
        this.Profit.value = raw?.Profit || 0;
    }
}
